import { render, staticRenderFns } from "./DinerSettings.vue?vue&type=template&id=724b65dc&scoped=true"
import script from "./DinerSettings.vue?vue&type=script&lang=js"
export * from "./DinerSettings.vue?vue&type=script&lang=js"
import style0 from "./DinerSettings.vue?vue&type=style&index=0&id=724b65dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724b65dc",
  null
  
)

export default component.exports